import i18n from '../../../../i18n'

import { EmailSelectTemplateToTestOptionValue } from './EmailSelectTemplateToTestVariablesModal.constants'

export function getOptions() {
  return [
    {
      id: EmailSelectTemplateToTestOptionValue.textTemplate,
      label: i18n.t('Email.ConfirmationModalEmailTemplateValueOptionKey'),
    },
    {
      id: EmailSelectTemplateToTestOptionValue.googleTemplate,
      label: i18n.t('Email.ConfirmationModalGoogleTemplateValueOptionKey'),
    },
  ]
}
